import ApiClient from '@/api/ApiClient';

const ROUTE = 'tempworker/unavailability';
const client = new ApiClient(ROUTE);

class UnavailabilityApiTempWorker {

	static list () {
		return client.get<IUnavailabilityModel[]>('');
	}

	static add (addUnavailabilityModel: IAddUnavailabilityModel) {
		return client.post<IUnavailabilityModel>('', addUnavailabilityModel);
	}

	static delete (id: number) {
		return client.delete(id.toString());
	}

}

export default UnavailabilityApiTempWorker;
